module.exports = __webpack_public_path__ + "static/media/chain-item-three.adee0399.png";